import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PipesModule } from '../pipes/pipes.module';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs.component';

@NgModule({
  exports: [TabComponent, TabsComponent],
  imports: [CommonModule, PipesModule, TabComponent, TabsComponent],
})
export class TabsModule {}
export { TabComponent } from './tab/tab.component';
export { TabsComponent } from './tabs.component';
